<template>
  <div class="gxxt-card" :style="{'background-color': color}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props:{
    color: {
      type: String,
      default: '#fff'
    }
  }
}
</script>

<style scoped>
.gxxt-card{
  border-radius: 10px;
}
</style>